import React, { useState, useEffect } from 'react';
import { translate } from 'react-switch-lang';
import { ListingDatatable } from '../../_fragments';
import Form from './Form';
import { reasonSchema as schema } from '../../_validationSchema';
import { reasonAction as actions } from '../../_action/reason.action';
import { reason_model as model } from '../../_model';
import { reasonConstants as constants } from '../../_constants';

import { useSelector } from 'react-redux';

const Reason = (props) => {
  const { t } = props;

  const header = { name: 'Reason', icon: 'cubes' };
  const reducer = useSelector((state) => state.reasonOperation);
  const [item, setItem] = React.useState({});

  const filenameXML = 'Reasons';
  const menuCode = 'M_REASON';
  const columns = [
    { title: t('code'), field: 'Code' },
    { title: t('description'), field: 'Description' },
    { title: t('type'), field: 'ReasonTypeDesc' },
  ];
  let useService = () => {
    return [schema, actions, model, constants];
  };
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelected] = useState('');
  const [type, setFormType] = useState('');
  const [keyTrigger, setTrigger] = useState(false);
  useEffect(() => {
    if (open === false) {
      setFormType('');
      setTrigger(!keyTrigger);
    }
  }, [open]);
  useEffect(() => {
    if (reducer.getSuccess) {
      setItem(reducer.data.data.info);
    }
  }, [reducer]);
  return (
    <>
      <Form
        type={type}
        header={header}
        code={selectedCode}
        open={open}
        setClose={() => setOpen(false)}
        useService={useService}
        reducer={reducer}
        item={item}
      />
      <ListingDatatable
        key={keyTrigger}
        header={header}
        columns={columns}
        filenameXML={filenameXML}
        setSelected={setSelected}
        setFormOpen={setOpen}
        setFormType={setFormType}
        menuCode={menuCode}
      />
    </>
  );
};

export default translate(Reason);
